import { render, staticRenderFns } from "./SdssTrueColor.vue?vue&type=template&id=4ad6e756&scoped=true&lang=pug"
import script from "./SdssTrueColor.vue?vue&type=script&lang=ts"
export * from "./SdssTrueColor.vue?vue&type=script&lang=ts"
import style0 from "./SdssTrueColor.vue?vue&type=style&index=0&id=4ad6e756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad6e756",
  null
  
)

export default component.exports